// extracted by mini-css-extract-plugin
export default {"modal":"Eda-z","modalContent":"Fda-z","footer":"Gda-z","cancelBtn":"Hda-z","disabled":"Ida-z","formWrapper":"Jda-z","fade":"Kda-z","fade-in":"Lda-z","iframe":"Mda-z"};